export default "__VITE_ASSET__DqJXbf3q__"